/* eslint-disable jsx-a11y/media-has-caption */
import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Combobox, Option, useId, Button } from '@fluentui/react-components';
import { Overlay } from '@bingads-webui-react/fabric-control';
import { AssetLibrarySpinner } from '@bingads-webui-campaign-react/asset-library-spinner';
import { PlayRegular, PauseRegular } from '@fluentui/react-icons';
import { HelpPopupInline } from '@bingads-webui-react/help-popup';

import { useStyles } from './style';

export const getLocalizedAudioName = (key, i18n) => {
  const localizedAudioNames = {
    'chill_calm_river_msft_mstr.aac': i18n.getString(_TL_('Calm river (chill)')),
    'chill_In_A_Dream_MSFT_MSTR.aac': i18n.getString(_TL_('In a dream (chill)')),
    'chill_keep_it_moving_msft_mstr.aac': i18n.getString(_TL_('Soft moves (chill)')),
    'chill_Open_Field_MSFT_MSTR.aac': i18n.getString(_TL_('Open field (chill)')),
    'chill_Rain_In_Japan_MSFT_MSTR.aac': i18n.getString(_TL_('Rain in Japan (chill)')),
    'chill_relaxation_msft_mstr.aac': i18n.getString(_TL_('Relaxation (chill)')),
    'chill_summer_breeze_msft_mstr.aac': i18n.getString(_TL_('Summer breeze (chill)')),
    'chill_sunshine_msft_mstr.aac': i18n.getString(_TL_('Sunshine (chill)')),
    'chill_Supernova_MSFT_MSTR.aac': i18n.getString(_TL_('Supernova (chill)')),
    'chill_Waves_MSFT_MSTR.aac': i18n.getString(_TL_('Waves (chill)')),
    'cinematic_disturbia_msft_mstr.aac': i18n.getString(_TL_('Disturbia (cinematic)')),
    'cinematic_full_throttle_msft_mstr.aac': i18n.getString(_TL_('Full throttle (cinematic)')),
    'cinematic_tackle_it_msft_mstr.aac': i18n.getString(_TL_('Ready for action (cinematic)')),
    'energetic_all_hyped_up_msft_mstr.aac': i18n.getString(_TL_('All hyped up (energetic)')),
    'energetic_beach_party_msft_mstr.aac': i18n.getString(_TL_('Beach party (energetic)')),
    'energetic_Bring_Up_The_Energy_MSFT_MSTR.aac': i18n.getString(_TL_('Bring the energy (energetic)')),
    'energetic_By_The_Shoreline_MSFT_MSTR.aac': i18n.getString(_TL_('Daytime fun (energetic)')),
    'energetic_Feelin\'_Fresh_MSFT_MSTR.aac': i18n.getString(_TL_('Feeling fresh (energetic)')),
    'energetic_Get_Excited_MSFT_MSTR.aac': i18n.getString(_TL_('Get excited (energetic)')),
    'energetic_get_this_msft_mstr.aac': i18n.getString(_TL_('Positive vibes (energetic)')),
    'energetic_glitter_msft_mstr.aac': i18n.getString(_TL_('Get moving (energetic)')),
    'energetic_ice_tea_msft_mstr.aac': i18n.getString(_TL_('Dance to the rhythm (energetic)')),
    'energetic_Pump_It_Up_MSFT_MSTR.aac': i18n.getString(_TL_('Pump it up (energetic)')),
    'energetic_right_away_msft_mstr.aac': i18n.getString(_TL_('Gaining speed (energetic)')),
    'fun_all_night_msft_mstr.aac': i18n.getString(_TL_('All night (fun)')),
    'fun_backseat_msft_mstr.aac': i18n.getString(_TL_('Cruising (fun)')),
    'fun_Block_Party_MSFT_MSTR.aac': i18n.getString(_TL_('Block party (fun)')),
    'fun_Chill_And_Wavey_MSFT_MSTR.aac': i18n.getString(_TL_('Waves (fun)')),
    'fun_Cloud_Walk_MSFT_MSTR.aac': i18n.getString(_TL_('Walking on clouds (fun)')),
    'fun_Fearless_Funk_MSFT_MSTR.aac': i18n.getString(_TL_('Summertime beats (fun)')),
    'fun_get_going_msft_mstr.aac': i18n.getString(_TL_('Groove with it (fun)')),
    'fun_go_hard_msft_mstr.aac': i18n.getString(_TL_('Bliss (fun)')),
    'fun_Laid_Back_Vibe_MSFT_MSTR.aac': i18n.getString(_TL_('Catch the sun (fun)')),
    'fun_Liquid_MSFT_MSTR.aac': i18n.getString(_TL_('Cool as water (fun)')),
    'fun_Spectra_MSFT_MSTR.aac': i18n.getString(_TL_('Up for anything (fun)')),
    'fun_spring_city_msft_mstr.aac': i18n.getString(_TL_('Spring time (fun)')),
    'fun_The_Bounce_MSFT_MSTR.aac': i18n.getString(_TL_('Bounce step (fun)')),
    'inspiring_anodized_msft_mstr.aac': i18n.getString(_TL_('Looking to the future (inspiring)')),
    'inspiring_Awakenings_MSFT_MSTR.aac': i18n.getString(_TL_('Awakenings (inspiring)')),
    'inspiring_Closed_Circuits_MSFT_MSTR.aac': i18n.getString(_TL_('Open circuits (inspiring)')),
    'inspiring_Cutting_Edge_MSFT_MSTR.aac': i18n.getString(_TL_('Innovation (inspiring)')),
    'inspiring_Driving_Force_MSFT_MSTR.aac': i18n.getString(_TL_('Driving force (inspiring)')),
    'inspiring_happy_place_msft_mstr.aac': i18n.getString(_TL_('Happy place (inspiring)')),
    'inspiring_in_the_sky_msft_mstr.aac': i18n.getString(_TL_('Catching air (inspiring)')),
    'inspiring_Isotope_MSFT_MSTR.aac': i18n.getString(_TL_('Journeying (inspiring)')),
    'inspiring_look_around_msft_mstr.aac': i18n.getString(_TL_('Taking in the view')),
    'inspiring_Morning_Coffee_MSFT_MSTR.aac': i18n.getString(_TL_('Morning coffee (inspiring)')),
    'inspiring_sunshine_in_my_mind_msft_mstr.aac': i18n.getString(_TL_('Sunshine all the time (inspiring)')),
    'inspiring_Tinkering_MSFT_MSTR.aac': i18n.getString(_TL_('Spring cleaning (inspiring)')),
    'sentimental_homecoming_msft_mstr.aac': i18n.getString(_TL_('Homecoming (sentimental)')),
    'sentimental_not_guilty_msft_mstr.aac': i18n.getString(_TL_('Know you\'re great (sentimental)')),
    'sentimental_rising_star_msft_mstr.aac': i18n.getString(_TL_('Stargazing (sentimental)')),
  };

  return localizedAudioNames[key] || key;
};

export const EditVideoAudioView = ({
  i18n,
  audioState,
  setAudioState,
  rawAudioList,
}) => {
  const selectId = useId();
  const classes = useStyles();

  const [selectedValue, setSelectedValue] = useState();
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [audioList, setAudioList] = useState([]);
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);

  const audioSrc = useMemo(() => audioState && audioState.updating && audioState.updating.fileName, [audioState]);
  const audioName = useMemo(() => audioState && audioState.updating && audioState.updating.audioName, [audioState]);

  const togglePlayPause = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  const formatResponse = useCallback((response) => {
    if (!response || !response.Data || !response.Data.Audio) {
      return [];
    }

    return response.Data.Audio.map(item => ({
      key: item.Url,
      text: getLocalizedAudioName(item.AudioName, i18n),
    }));
  }, []);

  const getAudioObjectFromList = useCallback((key) => {
    if (!audioList || audioList.length === 0) {
      return null;
    }
    return audioList.find(item => item.key === key);
  });

  const handleChange = (event, data) => {
    const audioObject = getAudioObjectFromList(data.optionValue);
    if (audioObject) {
      setSelectedValue(data.optionText);
      setAudioState(prev => ({
        ...prev,
        updating: {
          ...prev.updating,
          fileName: audioObject.key,
          audioName: audioObject.text,
        },
      }));
    }

    if (isPlaying) {
      audioRef.current.pause();
      setIsPlaying(false);
    }
  };

  const formatAudioList = useCallback(async () => {
    const formattedList = formatResponse(rawAudioList);
    setAudioList(formattedList);
    if (formattedList.length > 0) {
      setSelectedValue(getLocalizedAudioName(audioName, i18n) || formattedList[0].text);
    }
    setIsPageLoading(false);
  }, [rawAudioList, formatResponse]);

  useEffect(() => {
    formatAudioList();
  }, [formatAudioList]);

  return (
    <div className={classes.audioGuideContainer} >
      {isPageLoading && (
        <Overlay styles={{ root: { zIndex: 1 } }}>
          <AssetLibrarySpinner className="page-load-spinner" useCustomSize />
        </Overlay>
      )}
      <div className={classes.audioGuideTitle}>{i18n.getString(_TL_('Choose audio for your video'))}</div>
      <div className={classes.audioMusicContainer}>
        <div className={classes.audioMusicTitleContainer}>
          <div className={classes.audioMusicTitle}>{i18n.getString(_TL_('Music'))}</div>
          <HelpPopupInline topic="pop_BA_VideoTemplates_Music" />
        </div>
        <div className={classes.audioMusicSelect}>
          <Combobox
            id={selectId}
            value={selectedValue}
            onOptionSelect={handleChange}
            style={{
              border: '1px solid',
              borderRadius: '4px',
              padding: '4px',
              minWidth: '215px',
              marginRight: '10px',
            }}
          >
            {!isPageLoading && audioList.length > 0 && audioList.map(option => (
              <Option key={option.key} value={option.key}>
                {option.text}
              </Option>
            ))}
          </Combobox>
          <Button
            onClick={togglePlayPause}
            icon={isPlaying ? <PauseRegular /> : <PlayRegular />}
            className="play-audio-button"
          />
        </div>
        <audio ref={audioRef} src={audioSrc} type="audio/aac" />
        {/* if needed we can use play/pause controls as well */}
        {/* <audio controls="controls" src={audioSrc} type="audio/aac" /> */}
      </div>
    </div>
  );
};


EditVideoAudioView.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  copilotDomainDataService: PropTypes.shape({
    getAudioList: PropTypes.func,
  }).isRequired,
  audioState: PropTypes.string.isRequired,
  setAudioState: PropTypes.func.isRequired,
};

EditVideoAudioView.defaultProps = {
};
